import type { FetchError } from "@repo/api-sdk";
import sdk from "@repo/api-sdk";
import type { UseMutationOptions } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";

/**
 * Set the signed-in salon's password.
 *
 * Runs against the current session rather than a reset-token round-trip: the
 * salon is already authenticated (they arrived through a concierge link), and
 * a reset email would arrive before the welcome one this flow deliberately
 * delays until activation.
 *
 * Resolves with `is_first_password` - true only for an actual activation, which
 * is what triggers the welcome email server-side.
 */
export const useSetPassword = (
  options?: UseMutationOptions<
    { is_first_password: boolean },
    FetchError,
    string
  >
) => {
  return useMutation({
    mutationFn: (password: string) => sdk.store.customer.setPassword(password),
    ...options
  });
};
